import React, { useState } from "react";

import axios from "axios";
import AddProductPage from "./AddProductPage.js";
import UpdateProductPage from "./UpdateProductPage.js";
import DeleteProductPage from "./DeleteProductPage.js";
import ListProductPage from "./ListProductPage.js";
import ListRequestedPage from "./ListRequestedPage.js";
import ListGrantedPage from "./ListGrantedPage.js";

import LoadingGif from "../../../assets/images/Spin_loader.gif"

function AdminPage({ setParentLoading, activeAdminTab }) {
   
    return (
        <div >

                {/* CONTENTS */}

                <div
                    style={{
                    width: "100%",
                    minHeight: "100vh",
                    overflowY: "auto",
                    backgroundColor: "white",
                    padding: "10px",
                    boxSizing: "border-box"
                    }}
                >

                    {/* ADD PRODUCTS */}

                    {activeAdminTab === "addproducts" &&
                        <div className="fade-container">
                            <AddProductPage  setParentLoading={setParentLoading} />
                        </div>
                    }

                    {/* UPDATE PRODUCTS */}

                    {activeAdminTab === "updateproducts" &&
                        <div className="fade-container">
                            <UpdateProductPage setParentLoading={setParentLoading} />
                        </div>
                    }

                    {/* DELETE PRODUCTS */}

                    {activeAdminTab === "deleteproducts" && <div className="fade-container">
                        <DeleteProductPage setParentLoading={setParentLoading} />
                    </div>
                    }
                    {/* LIST PRODUCTS */}

                    {activeAdminTab === "listproducts" && <div className="fade-container">
                        <ListProductPage setParentLoading={setParentLoading} />
                    </div>
                    }

                    {/* REQUESTED LIST */}

                    {activeAdminTab === "requestedlistproducts" &&
                    <div className="fade-container">
                        <ListRequestedPage setParentLoading={setParentLoading} />
                    </div>
                     }

                    {/* GRANTED LIST */}

                    {activeAdminTab === "grantedlistproducts" && 
                      <div className="fade-container">
                    <ListGrantedPage setParentLoading={setParentLoading}/>
                      </div>
                    }


                </div>
           

           

        </div>
    )
}


export default AdminPage;